var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlt4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 600,
    viewBox: "0 0 1200 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_617_10565)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 600,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_617_10565)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1202.88,
    height: 813.478,
    transform: "translate(-1)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_617_10565)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1626.96,
    height: 915.163,
    transform: "translate(-212.593 -50.8422)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_617_10565)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1626.96,
    height: 915.163,
    transform: "translate(-212.593 -50.8422)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_617_10565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.031 -82.4919V1785.36",
    stroke: "#ECEBFC",
    strokeWidth: 1.33228
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.013 -82.4919V1785.36",
    stroke: "#ECEBFC",
    strokeWidth: 1.33228
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.49 -82.4919V1785.36",
    stroke: "#ECEBFC",
    strokeWidth: 1.33228
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.916 -82.4919V1785.36",
    stroke: "#ECEBFC",
    strokeWidth: 1.33228
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.771 -82.4919V1785.36",
    stroke: "#ECEBFC",
    strokeWidth: 1.33228
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.556 -82.4919V1785.36",
    stroke: "#ECEBFC",
    strokeWidth: 1.33228
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.807 -82.4919V1785.36",
    stroke: "#ECEBFC",
    strokeWidth: 1.33228
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1149.09 -82.4919V1785.36",
    stroke: "#ECEBFC",
    strokeWidth: 1.33228
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333.04 16.5055H1534.81",
    stroke: "#ECEBFC",
    strokeWidth: 1.33228
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333.04 121.44H1534.81",
    stroke: "#ECEBFC",
    strokeWidth: 1.33228
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333.04 232.671H1534.81",
    stroke: "#ECEBFC",
    strokeWidth: 1.33228
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333.04 350.579H1534.81",
    stroke: "#ECEBFC",
    strokeWidth: 1.33228
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-333.04 475.561H1534.81",
    stroke: "#ECEBFC",
    strokeWidth: 1.33228
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1821.14 263.712C1821.14 528.452 1678.26 768.161 1447.2 941.698C1216.13 1115.24 896.889 1222.58 544.252 1222.58C191.615 1222.58 -127.623 1115.24 -358.691 941.698C-589.76 768.161 -732.64 528.452 -732.64 263.712C-732.64 -1.02808 -589.76 -240.737 -358.691 -414.274C-127.623 -587.812 191.615 -695.16 544.252 -695.16C896.889 -695.16 1216.13 -587.812 1447.2 -414.274C1678.26 -240.737 1821.14 -1.02808 1821.14 263.712Z",
    fill: "url(#paint0_radial_617_10565)",
    stroke: "#ECEBFC",
    strokeWidth: 0.831634
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_617_10565)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_617_10565)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -59.2324,
    y: 485.865,
    width: 120.021,
    height: 120.021,
    stroke: "#7D67EB",
    strokeWidth: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.15,
    y: 485.865,
    width: 120.021,
    height: 120.021,
    stroke: "#7D67EB",
    strokeWidth: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.842,
    y: 485.865,
    width: 120.021,
    height: 120.021,
    stroke: "#7D67EB",
    strokeWidth: 18.67
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_617_10565)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 470.64,
    y: -55.1212,
    width: 120.021,
    height: 89.5715,
    stroke: "#7D67EB",
    strokeWidth: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470.64,
    y: 53.1203,
    width: 120.021,
    height: 89.5715,
    stroke: "#7D67EB",
    strokeWidth: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: 609.331,
    y: -55.1212,
    width: 120.021,
    height: 89.5715,
    stroke: "#7D67EB",
    strokeWidth: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: 748.022,
    y: -55.1212,
    width: 120.021,
    height: 89.5715,
    stroke: "#7D67EB",
    strokeWidth: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.713,
    y: -55.1212,
    width: 120.021,
    height: 89.5715,
    stroke: "#7D67EB",
    strokeWidth: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: 886.713,
    y: 53.1203,
    width: 120.021,
    height: 89.5715,
    stroke: "#7D67EB",
    strokeWidth: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1025.41,
    y: -55.1212,
    width: 120.021,
    height: 89.5715,
    stroke: "#7D67EB",
    strokeWidth: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1025.41,
    y: 53.1203,
    width: 120.021,
    height: 89.5715,
    stroke: "#7D67EB",
    strokeWidth: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1164.1,
    y: -55.1212,
    width: 120.021,
    height: 89.5715,
    stroke: "#7D67EB",
    strokeWidth: 18.67
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1164.1,
    y: 53.1203,
    width: 120.021,
    height: 89.5715,
    stroke: "#7D67EB",
    strokeWidth: 18.67
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_617_10565",
    x: -698.013,
    y: 401.85,
    width: 1536.27,
    height: 704.126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.34,
    result: "effect1_foregroundBlur_617_10565"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_617_10565",
    x: 386.625,
    y: -355.62,
    width: 1536.27,
    height: 582.326,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.34,
    result: "effect1_foregroundBlur_617_10565"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_617_10565",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(544.252 263.712) rotate(90) scale(959.288 1277.31)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.205,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_617_10565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 600,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_617_10565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1202.88,
    height: 813.478,
    fill: "white",
    transform: "translate(-1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_617_10565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1626.96,
    height: 915.163,
    fill: "white",
    transform: "translate(-212.593 -50.8422)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_617_10565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1626.96,
    height: 915.163,
    fill: "white",
    transform: "translate(-212.593 -50.8422)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_617_10565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1867.85,
    height: 979.222,
    fill: "white",
    transform: "translate(-333.04 -82.3723)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_617_10565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1626.96,
    height: 915.163,
    fill: "white",
    transform: "translate(-212.593 -50.8422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlt4);
export default __webpack_public_path__ + "static/media/alt4.68c975e7d2a962a37ea4e12eb0dd84f9.svg";
export { ForwardRef as ReactComponent };